import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType, ref } from 'vue';
import { ExternalRecommendation, feedBackType2SmileyType, RecommendationFeedbackType } from '@/models/Recommendations';
import BCXTable from '@/components/BCXTable.vue';
import useI18n from '@/mixins/useI18n';
import useFormattedDateTime from '@/mixins/useFormattedDateTime';
import BCXAvatar from '@/components/molecules/BCXAvatar.vue';
import BCXLinkedUser from '@/components/molecules/BCXLinkedUser.vue';
import { getDisplayName, getNameSortString } from '@/utils/user';
import BCXChevronSwitch from '@/components/molecules/BCXChevronSwitch.vue';
import Smiley from '@/components/svg-components/Smiley.vue';
import RecommendationsFeedbackCard from '@/views/recommendations/components/RecommendationsFeedbackCard.vue';
import toggleArrayItem from '@/utils/toggleArrayItem';
import { BcxTableFilter } from '@/models/BcxTable';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyRecommendationsTableNew',
  props: {
  recommendations: {
    type: Array as PropType<ExternalRecommendation[]>,
    default: () => []
  }
},
  setup(__props) {

const props = __props;




const { t } = useI18n();
const { getFormattedDate } = useFormattedDateTime();

const openedFeedbacks = ref<string[]>([]);

const fields = ['user', 'project', 'date', 'feedback'];

const headerTitles = computed(() => [
  t('recommendations.myRecommendations.table.toUser'),
  t('recommendations.myRecommendations.table.project'),
  t('recommendations.myRecommendations.table.date'),
  t('recommendations.myRecommendations.table.feedback'),
]);

const displayValueCallback = (field: string, obj: ExternalRecommendation) => {
  switch (field) {
    case 'user': return obj.recommendedUser;
    case 'project': return obj.project;
    case 'date': return getFormattedDate(obj.created);
    case 'feedback': return obj.recommendedUserFeedback;
  }
  return 0;
};

const sortValueCallback = (field: string, obj: ExternalRecommendation) => {
  switch (field) {
    case 'user': return getNameSortString(obj.recommendedUser);
    case 'project': return obj.project.title;
    case 'date': return obj.created;
    case 'feedback': {
      const values: Record<RecommendationFeedbackType, number> = {
        [RecommendationFeedbackType.Negative]: 1,
        [RecommendationFeedbackType.Neutral]: 2,
        [RecommendationFeedbackType.Positive]: 3
      };
      return values[obj.recommendedUserFeedback] ?? 0;
    }
  }
  return 0;
};

const searchCallback = (search: string, obj: ExternalRecommendation) => {
  const searchBlock = (
    `${obj.project.title} ${getDisplayName(obj.recommendedUser)}`
  ).toLocaleLowerCase();
  return searchBlock.includes(search.toLocaleLowerCase());
};

const toggleFeedback = (id: string) => {
  toggleArrayItem(openedFeedbacks.value, id);
};

const filter = computed((): BcxTableFilter => ({
  style: 'dropdown',
  isExclusive: false,
  states: ['POSITIVE', 'NEUTRAL', 'NEGATIVE', 'NONE'],
  stateCallback: (states: string[], obj: ExternalRecommendation) => states.includes(obj.recommendedUserFeedback ?? 'NONE'),
  labelCallback: (state: string) => `${t(`recommendations.myRecommendations.filter.${state}`)}`
}));


return { __sfc: true,props, t, getFormattedDate, openedFeedbacks, fields, headerTitles, displayValueCallback, sortValueCallback, searchCallback, toggleFeedback, filter, feedBackType2SmileyType, BCXTable, BCXAvatar, BCXLinkedUser, getDisplayName, BCXChevronSwitch, Smiley, RecommendationsFeedbackCard }
}

})